// Full-document render of the Oscar address-book list view: PageSkeleton
// wrapping AddressListPageBody.
import React from "react";

import { templates } from "@reactivated";

import { AddressListPageBody } from "../components/AddressListPageBody";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.AddressListDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <AddressListPageBody {...props} />
    </PageSkeleton>
);
